import { Controller } from "@hotwired/stimulus";

export default class FilterableController extends Controller<HTMLElement> {
  static targets = ["input", "item", "text"];
  declare readonly hasTextTarget: boolean;
  declare readonly inputTarget: HTMLInputElement;
  declare readonly itemTarget: HTMLElement[];
  declare readonly itemTargets: HTMLElement[];
  declare readonly textTarget: HTMLElement;
  declare readonly textTargets: HTMLElement[];

  filter(): void {
    const query = this.inputTarget.value.toLowerCase();

    this.itemTargets.forEach((item, index) => {
      let textElement: HTMLElement;

      if (this.hasTextTarget) {
        textElement = this.textTargets[index];
      } else {
        textElement = item;
      }

      const text = textElement.innerText.toLowerCase();

      if (!text.includes(query)) {
        item.classList.add("hidden");
      } else {
        item.classList.remove("hidden");
      }
    });
  }
}
